import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DefaultStockItemComponent} from "./stock-item/default-stock-item.component";
import {RecordModule} from "../../record/record.module";
import {UtilityModule} from "../../utility/utility.module";
import {AngularMaterialModule} from "../../angular-material.module/angular-material.module.module";
import {
  DefaultFeatureprintListViewComponent
} from "./featureprint-list-view/default-featureprint-list-view.component";
import {RouterLink} from "@angular/router";
import {
  DefaultIdentificationsListViewComponent
} from "./identifications-list-view/default-identifications-list-view.component";
import {DefaultStatsViewComponent} from "./stats-view/default-stats-view.component";
import {DefaultFacetComponent} from "./facet/default-facet.component";

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    RecordModule,
    UtilityModule,
    RouterLink
  ],
  declarations: [
    DefaultStockItemComponent
    , DefaultFeatureprintListViewComponent
    , DefaultIdentificationsListViewComponent
    , DefaultStatsViewComponent
    , DefaultFacetComponent
  ],
  exports: [
    DefaultStockItemComponent,
    DefaultFeatureprintListViewComponent,
    DefaultIdentificationsListViewComponent,
    DefaultStatsViewComponent,
    DefaultFacetComponent
  ],
  providers: []
})
export class DefaultCustomerModule {
}

export interface IdWithIndex {
  id: string;
  index: number;
}
